import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

declare const $: any;
declare const Cookies: any;

@Component({
  selector: 'app-sidebar-partial',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './sidebar-partial.component.html',
  styleUrls: ['./sidebar-partial.component.scss'],
})
export class SidebarPartialComponent implements OnInit {
  public user: any = null;

  public menus: Array<any> = [
    {
      title: 'DASHBOARD',
      icon: 'fa fa-home',
      url: ['/admin/dashboard'],
      has_sub: false,
      children: [],
    },
    {
      title: 'BNC',
      icon: 'fas fa-university',
      url: null,
      has_sub: true,
      children: [
        {
          title: 'BANKS',
          url: ['/admin/banks'],
        },
        {
          title: 'CURRENT POSITION',
          url: ['/admin/current-position'],
        },
        {
          title: 'PAYMENT NOTIFICATIONS',
          url: ['/admin/payment-notifications'],
        },
      ],
    },
  ];

  public menus2: Array<any> = [
    {
      title: 'DASHBOARD',
      icon: 'fa fa-home',
      url: ['/admin/dashboard'],
      has_sub: false,
      children: [],
    },
    {
      title: 'HOTSPOT',
      icon: 'fas fa-wifi',
      url: null,
      has_sub: true,
      children: [
        {
          title: 'COBROS C2P',
          url: ['/admin/hotspot/cobros-c2p'],
        },
        {
          title: 'ESTADISTICAS',
          url: ['/admin/hotspot/estadisticas'],
        },
      ],
    },
    {
      title: 'MIKROWISP',
      icon: 'fas fa-desktop',
      url: null,
      has_sub: true,
      children: [
        {
          title: 'MIGRAR SERVICIOS',
          url: ['/admin/mikrowisp/migrar-servicios'],
        },
      ],
    },
    {
      title: 'PROFIT',
      icon: 'fas fa-desktop',
      url: null,
      has_sub: true,
      children: [
        {
          title: 'CLIENTES',
          url: ['/admin/profit/clientes'],
        },
        {
          title: 'FACTURAS DE VENTA',
          url: ['/admin/profit/facturas-de-venta'],
        },
        {
          title: 'NOTAS DE CRÉDITO',
          url: ['/admin/profit/notas-de-credito'],
        },
        {
          title: 'PISTAS',
          url: ['/admin/profit/pistas'],
        },
      ],
    },
    {
      title: 'TECNOSYSTEM',
      icon: 'fas fa-building',
      url: null,
      has_sub: true,
      children: [
        {
          title: 'REPORTES DE PAGOS',
          url: ['/admin/tecnosystem/payment-reports'],
        },
        {
          title: 'ENLACES DE PAGOS',
          url: ['/admin/tecnosystem/payment-links'],
        },
      ],
    },
    // {
    //   title: this._version.full_version,
    //   icon: 'fas fa-code-branch',
    //   url: null,
    //   has_sub: false,
    //   children: [],
    // },
  ];

  constructor(private _api: ApiService) {
    console.log('SidebarPartialComponent constructor');
  }

  async ngOnInit(): Promise<void> {
    console.log('SidebarPartialComponent ngOnInit');

    this._api.userObservable.subscribe({
      next: (user: any) => {
        console.log('SidebarPartialComponent userObservable user', user);
        this.user = user;

        this.initScripts();
      },
      error: (error: any) => {
        console.log('SidebarPartialComponent userObservable error', error);
        this.user = null;
      },
    });
  }

  ngOnDestroy(): void {
    console.log('SidebarPartialComponent ngOnDestroy');
  }

  public initScripts(): void {
    $(document).on('click', '[data-click="sidebar-minify"]', (e: any) => {
      e.preventDefault();
      let sidebarClass = 'page-sidebar-minified';
      let targetContainer = 'page-container';
      let sidebarMinified = false;

      const pageContainer: HTMLElement | null =
        document.getElementById(targetContainer);

      let targetHasClass: any =
        pageContainer!.classList.contains(targetContainer);

      if (targetHasClass) {
        $(targetContainer).removeClass(sidebarClass);
      } else {
        $(targetContainer).addClass(sidebarClass);

        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          $('#sidebar [data-scrollbar="true"]').css('margin-top', '0');
          $('#sidebar [data-scrollbar="true"]').css('overflow-x', 'scroll');
        }
        sidebarMinified = true;
      }
      $(window).trigger('resize');

      if (Cookies) {
        Cookies.set('sidebar-minified', sidebarMinified);
      }
    });
    if (Cookies) {
      let sidebarMinified = Cookies.get('sidebar-minified');

      if (sidebarMinified == 'true') {
        $('#page-container').addClass('page-sidebar-minified');
      }
    }
  }

  public clickMenu(menu: any): void {
    console.log('clickMenu menu', menu);

    let expandTime = $('.sidebar').attr('data-disable-slide-animation')
      ? 0
      : 250;

    let target = $(menu).next('.sub-menu');
    let otherMenu = $('.sidebar .nav > li.has-sub > .sub-menu').not(target);

    if ($('.page-sidebar-minified').length === 0) {
      $(otherMenu).closest('li').addClass('closing');
      $(otherMenu).slideUp(expandTime, function () {
        $(otherMenu)
          .closest('li')
          .addClass('closed')
          .removeClass('expand closing');
      });
      if ($(target).is(':visible')) {
        $(target).closest('li').addClass('closing').removeClass('expand');
      } else {
        $(target).closest('li').addClass('expanding').removeClass('closed');
      }
      $(target).slideToggle(expandTime, function () {
        let targetLi = $(menu).closest('li');
        if (!$(target).is(':visible')) {
          $(targetLi).addClass('closed');
          $(targetLi).removeClass('expand');
        } else {
          $(targetLi).addClass('expand');
          $(targetLi).removeClass('closed');
        }
        $(targetLi).removeClass('expanding closing');
      });
    }
  }

  public clickSubMenu(subMenu: any): void {
    console.log('clickSubMenu subMenu', subMenu);

    let expandTime = $('.sidebar').attr('data-disable-slide-animation')
      ? 0
      : 250;

    $(document).on(
      'click',
      '.sidebar .nav > .has-sub .sub-menu li.has-sub > a'
    );

    if ($('.page-sidebar-minified').length === 0) {
      let target = $(subMenu).next('.sub-menu');
      if ($(target).is(':visible')) {
        $(target).closest('li').addClass('closing').removeClass('expand');
      } else {
        $(target).closest('li').addClass('expanding').removeClass('closed');
      }
      $(target).slideToggle(expandTime, function () {
        let targetLi = $(subMenu).closest('li');
        if (!$(target).is(':visible')) {
          $(targetLi).addClass('closed');
          $(targetLi).removeClass('expand');
        } else {
          $(targetLi).addClass('expand');
          $(targetLi).removeClass('closed');
        }
        $(targetLi).removeClass('expanding closing');
      });
    }
  }
}
